export const ACTION_TYPES = {
  OPEN: "DIALOGS/OPEN",
  CLOSE: "DIALOGS/CLOSE",
};

export const initialState = [];

/**
 * Dialogs reducer
 *
 * This reducer manages the state of dialogs in the application.
 * It handles opening and closing dialogs based on the dispatched actions.
 *
 * @param {Array} state - The current state of the dialogs.
 * @param {Object} action - The action dispatched to the reducer.
 * @returns {Array} The updated state of the dialogs.
 */
export const dialogsReducer = (state = initialState, { type, payload }) => {
  if (type === ACTION_TYPES.OPEN) return [...state, payload];
  if (type === ACTION_TYPES.CLOSE) {
    state.pop();
    return [...state];
  }
  return state;
};
